//championship.service.ts
import { config } from "config";
import type { Championship } from "championship/types/championship.model";

export class ChampionshipService {
  private static headers() {
    return {
      Authorization: `Bearer ${JSON.parse(
        sessionStorage.getItem("quizToken")!
      )}`,
      "Content-Type": "application/json",
    };
  }

  async fetchChampionshipData(championshipId: string): Promise<Championship> {
    const resp = await fetch(
      `${config.apiRoot}/championships/${championshipId}`,
      {
        method: "GET",
        headers: ChampionshipService.headers(),
      }
    );

    if (!resp.ok) {
      throw new Error(`Failed to fetch championship data: ${resp.statusText}`);
    }

    return await resp.json();
  }

  async createChampionship(
    data: Omit<Championship, "id">
  ): Promise<Championship> {
    const resp = await fetch(`${config.apiRoot}/championships`, {
      method: "POST",
      headers: ChampionshipService.headers(),
      body: JSON.stringify(data),
    });

    if (!resp.ok) {
      throw new Error(`Failed to create championship: ${resp.statusText}`);
    }

    return await resp.json();
  }

  async updateChampionship(
    id: string,
    data: Partial<Championship>
  ): Promise<Championship> {
    const resp = await fetch(`${config.apiRoot}/championships/${id}`, {
      method: "POST",
      headers: ChampionshipService.headers(),
      body: JSON.stringify(data),
    });

    if (!resp.ok) {
      throw new Error(`Failed to update championship: ${resp.statusText}`);
    }

    return await resp.json();
  }

  async deleteChampionship(id: string): Promise<void> {
    const resp = await fetch(`${config.apiRoot}/championships/${id}`, {
      method: "DELETE",
      headers: ChampionshipService.headers(),
    });

    if (!resp.ok) {
      throw new Error(`Failed to delete championship: ${resp.statusText}`);
    }
  }

  async getAllChampionships(): Promise<Championship[]> {
    const resp = await fetch(`${config.apiRoot}/championships`, {
      method: "GET",
      headers: ChampionshipService.headers(),
    });

    if (!resp.ok) {
      throw new Error(`Failed to fetch championships: ${resp.statusText}`);
    }

    return await resp.json();
  }
}
